import React, {Component} from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {reduxForm, Field, stopSubmit, startSubmit} from 'redux-form'

import BackOfficeVehiclesScreen from '../screens/BackOfficeVehiclesScreen'
import SostaOnlineApiService from '../services/SostaOnlineApiService'

const mapStateToProps = (state) => {
  return {
    state: state.users
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

class BackOfficeVehiclesTableContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      vehicles: [],
      count: 0,
      filters: {}
    }

    this.onRowClick = this.onRowClick.bind(this)
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.onClearFilters = this.onClearFilters.bind(this)
    this.fetchVehicles = this.fetchVehicles.bind(this)
  }

  componentDidMount () {
    this.setState({loading: true})
    this.fetchVehicles()
  }

  onCreateVehicleClick () {
    this.props.history.push('/backoffice/vehicles/create')
  }

  fetchVehicles (filterObj, limit, offset) {
    this.setState({loading: true})
    let string = ''
    for (let key in filterObj) {
      string = string + key + '=' + filterObj[key] + '&'
    }

    SostaOnlineApiService.fetchVehicles(string, limit || 100, offset || 0).then((data) => {
      this.setState({
        vehicles: data.data,
        pagination: data.pagination,
        loading: false
      })
    })
  }

  handleFilterChange (filter) {
    let newFilters = Object.assign({}, this.state.filters)
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter
    } else {
      delete newFilters[filter.column.key]
    }
    this.setState({ filters: newFilters })
  }

  onRowClick (rowIdx, row) {
    if (rowIdx <= -1 || !row.userId) {
      return
    }

    this.props.history.push('/backoffice/users/' + row.userId + '?scrollTo=vehicle-' + row.id)
  }

  onClearFilters () {
    // all filters removed
    this.setState({filters: {}})
  }

  render () {
    return (
      <BackOfficeVehiclesScreen
        loading={this.state.loading}
        fetchVehicles={this.fetchVehicles}
        vehicles={this.state.vehicles}
        rows={this.state.vehicles}
        pagination={this.state.pagination}
        onRowClick={this.onRowClick.bind(this)}
        handleFilterChange={this.handleFilterChange.bind(this)}
        onClearFilters={this.onClearFilters.bind(this)} />
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeVehiclesTableContainer)



// WEBPACK FOOTER //
// ./src/containers/BackOfficeVehiclesTableContainer.js